export default "__VITE_ASSET__C2WC9sR4__";